import { Form } from "@formio/react";
import { Card } from "antd";
import "formiojs/dist/formio.full.min.css";
import _ from 'lodash-es';
import { useEffect, useRef, useState } from "react";

import request from "../../../libs/request";
import Evisit from "../../../libs/Evisit";
const GuestIntake = ({currentComponent, onNext, room, data}) => {
    const componentKey = "guest_intake";
    const [formIOComponents, setFormIOComponents] = useState({components: []});
    const formRef = useRef(null);

    const createGuestUser = async (data) => {
        var defaultData = {
            first_name: 'Guest User',
            last_name: ' ',
            type: 600,
            login: true
        };
        var ssoData = _.assign(defaultData, data);
        const response = await request.post(`${window.base_url}/api_v3/users/sso`, _.pick(ssoData,
            ['first_name', 'last_name', 'type', 'login']));
        window.user = _.clone(_.get(response, "data", {}));
        if (_.has(response, "data.token.token")) {
            window.user.token = response["data"]["token"]["token"];
        }
        Evisit.postMessageBackToParent({
            name: "user.created",
            data: response["data"]
        });
        return response;
    }

    const createIntake = async (submission) => {

        const getConsultation = () => {
            // Try to get first consultation of room
            var result = null;
            var consultations = _.get(room, 'payment.consultations', []);
            var visibleConsultations = _.filter(consultations, function(consultation) {
                return consultation.visible_to_patient !== false;
            });
            if (visibleConsultations.length) {
                result = visibleConsultations[0];
            } else if(consultations.length) {
                result = consultations[0];
            }
            return result;
        }

        var data = {
            street: submission.data.street,
            city: submission.data.city,
            state: submission.data.state,
            zipcode: submission.data.zip,
            paymentCurrency: "USD"
        };
        var consultation = getConsultation();
        if (consultation) {
            data["consultation"] = consultation;
        }
        const response = await request.post(`${window.base_url}/api_v3/intakes`, data);
        return response;
    }

    const onSubmit = async (submission) => {
        const userData = await createGuestUser(submission.data);
        const intakeData = await createIntake(submission);
        onNext({intake: intakeData["data"], user: userData["data"]});
    }

    useEffect(() => {
        const components = _.get(currentComponent, "input.form.components", []);
        if (components) {
            setFormIOComponents({components: components});
        }
    }, [currentComponent]);

    return (<>
        <h3 className="component-name">{ currentComponent.name || "" }</h3>
        <Card style={{ width: '100%' }}>
            <Form
                form={formIOComponents}
                formReady={(formInstance) => {
                    formRef.current = formInstance;
                    formInstance.submission = {
                        data: _.get(data, `${componentKey}.value`, {})
                    };
                }}
                onSubmit={(submission) => onSubmit(submission)}
                options={{
                    noAlerts: true,
                }}
            />
        </Card>
    </>);
}

export default GuestIntake;